var Backbone = require('backbone')
var _ = require('underscore')
module.exports = Backbone.Collection.extend({
  toJSON: function () {
    var result = Backbone.Collection.prototype.toJSON.call(this)
    return _.map(result, function (item) {
      return item.value
    })
  }
})
